import Shader from '../../shader'
import {simpleShader} from '../../util'
import * as store from '../../store'

/**
 * @filter         Ink
 * @description    Simulates outlining the image in ink by darkening edges stronger than a
 *                 certain threshold. The edge detection value is the difference of two
 *                 copies of the image, each blurred using a blur of a different radius.
 * @param strength The multiplicative scale of the ink edges. Values in the range 0 to 1
 *                 are usually sufficient, where 0 doesn't change the image and 1 adds lots
 *                 of black edges. Negative strength values will create white ink edges
 *                 instead of black ones.
 */
export default function(strength) {
  var gl = store.get('gl');
  gl.ink = gl.ink || new Shader(null, '\
    uniform sampler2D texture;\
    uniform float strength;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    void main() {\
      vec2 dx = vec2(1.0 / texSize.x, 0.0);\
      vec2 dy = vec2(0.0, 1.0 / texSize.y);\
      vec4 color = texture2D(texture, texCoord);\
      float bigTotal = 0.0;\
      float smallTotal = 0.0;\
      vec3 bigAverage = vec3(0.0);\
      vec3 smallAverage = vec3(0.0);\
      for (float x = -2.0; x <= 2.0; x += 1.0) {\
        for (float y = -2.0; y <= 2.0; y += 1.0) {\
          vec3 sample = texture2D(texture, texCoord + dx * x + dy * y).rgb;\
          bigAverage += sample;\
          bigTotal += 1.0;\
          if (abs(x) + abs(y) < 2.0) {\
            smallAverage += sample;\
            smallTotal += 1.0;\
          }\
        }\
      }\
      vec3 edge = max(vec3(0.0), bigAverage / bigTotal - smallAverage / smallTotal);\
      gl_FragColor = vec4(color.rgb - dot(edge, edge) * strength * 100000.0, color.a);\
    }\
  ');

  simpleShader.call(this, gl.ink, {
    strength: strength * strength * strength * strength * strength,
    texSize: [this.width, this.height]
  });

  return this;
}



// WEBPACK FOOTER //
// ./src/filters/fun/ink.js